export default __webpack_public_path__ + "static/media/pages.b24eaeda.svg";